import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Horas buscando el "prompt mágico" en TikTok que nunca funciona igual en tu caso', 'Resultados genéricos y aburridos que podrías haber escrito vos mismo en menos tiempo', 'Sin saber cuándo usar ChatGPT, cuándo DeepSeek y cuándo Claude — usás todo para todo', 'Contenido que claramente "parece IA" y nadie quiere leer ni compartir', 'Tareas que siguen tardando horas aunque "uses IA" porque no tenés el flujo correcto', 'Semana tras semana el mismo ciclo — mucho tiempo invertido, pocos resultados concretos'];
  return <section className="py-24 bg-card relative border-y border-white/5" data-id="element-155">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-157">
          <h2 className="text-3xl md:text-5xl font-display font-bold mb-6 text-white" data-id="element-158">
            ¿Cuántas horas más vas a perder así?
          </h2>
          <div className="space-y-4 text-lg text-gray-400" data-id="element-159">
            <p data-id="element-160">
              Querés dominar la Inteligencia Artificial. Sabés que el mundo
              cambió. Sabés que ChatGPT, DeepSeek y Claude son herramientas
              reales que otros ya están usando para ganar tiempo y dinero.
            </p>
            <p data-id="element-161">
              Pero nadie te dijo que ibas a pasar horas escribiendo prompts que
              no funcionan, obteniendo respuestas genéricas que no sirven para
              nada, sin entender cuál IA usar para qué tarea, y llegando al
              final del día con la sensación de que la IA "no es para ti".
            </p>
          </div>

          <div className="mt-8 p-6 bg-red-500/10 border border-red-500/20 rounded-xl inline-block" data-id="element-162">
            <p className="text-xl font-bold text-white" data-id="element-163">
              No es falta de inteligencia.
            </p>
            <p className="text-xl font-bold text-red-400 mt-1" data-id="element-164">
              Es falta de un sistema.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-165">
          <h3 className="text-xl font-bold mb-6 text-center text-gray-300" data-id="element-166">
            Lo que pasa cuando no tenés el sistema correcto:
          </h3>
          <div className="space-y-4" data-id="element-167">
            {points.map((point, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 glass-card p-4 rounded-lg" data-id="element-168">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-169" />
                <p className="text-gray-300" data-id="element-170">{point}</p>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-171">
          <h3 className="text-2xl md:text-3xl font-display font-bold text-cyan-400" data-id="element-172">
            ¿Y si esta fuera la última semana que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}